export default {
    commonColor: [
        'rgb(0, 221, 255)',
        'rgb(55, 162, 255)',
        'rgb(255, 0, 135)',
        'rgb(255, 191, 0)',
        'rgb(128, 192, 128)'
    ],
    gradientColor:[
        [
            {
              offset: 0,
              color: 'rgb(0, 221, 255)'
            },
            {
              offset: 1,
              color: 'rgb(77, 119, 255)'
            }
        ],
        [
            {
              offset: 0,
              color: 'rgb(55, 162, 255)'
            },
            {
              offset: 1,
              color: 'rgb(116, 21, 219)'
            }
        ],
        [
            {
              offset: 0,
              color: 'rgb(255, 0, 135)'
            },
            {
              offset: 1,
              color: 'rgb(135, 0, 157)'
            }
        ],
        [
            {
              offset: 0,
              color: 'rgb(255, 191, 0)'
            },
            {
              offset: 1,
              color: 'rgb(224, 62, 76)'
            }
        ],
        [
            {
              offset: 0,
              color: 'rgb(128, 192, 128)'
            },
            {
              offset: 1,
              color: 'rgb(65, 191, 0)'
            }
        ],
    ]
}